import {withTranslation} from "react-i18next";
import {BiBody} from "react-icons/bi";
import {FaWeight} from "react-icons/fa";
import {GiBodyHeight} from "react-icons/gi";
import {RiShieldCheckLine} from "react-icons/ri";
import {checkSpecialityToShowIMC} from "../../utils/checkSpecialityToShow";
// import {useContext, useEffect, useState} from "react";
// import {URL_API} from "../../constants/urls";
// import {AiOutlineFile} from "react-icons/ai";
// import {authContext} from "../../context/AuthContext";
// import useCompanyType from "../../hook/useCompanyType";

function InfoSencondaryPatient({t, paciente, cita}) {
    // const [modalidad, setModalidad] = useState(null);
    // const {auth} = useContext(authContext)
    // const company = useCompanyType()

    // useEffect(() => {
    //     const fetchModalidad = async () => {
    //         if (cita?.id) {
    //             try {
    //                 const response = await fetch(`${URL_API}/api/appointment/${cita.id}/modalidad`, {
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${auth.data.access_token}`,
    //                     },
    //                 });
    //                 const data = await response.json();
    //                 setModalidad(data.modalidad);
    //             } catch (error) {
    //                 console.error("Error fetching modalidad:", error);
    //             }
    //         }
    //     };
    //
    //     fetchModalidad();
    // }, [cita?.id]);

    return (
        <>
            <div className="d-flex text-secondary mb-3 font-size-09rem">
                <div><RiShieldCheckLine className="mr-2"/></div>
                <div><span>{paciente?.account != null ? paciente?.account?.name : ' - '}</span></div>
            </div>
            {
                (cita.peso && checkSpecialityToShowIMC(cita)) &&
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><FaWeight className="mr-2"/></div>
                    <div><span>{cita?.peso != null ? cita?.peso : '-'} Kg</span></div>
                </div>
            }
            {
                (cita.talla && checkSpecialityToShowIMC(cita)) &&
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><GiBodyHeight className="mr-2"/></div>
                    <div><span>{cita?.talla != null ? cita?.talla : '-'} cm</span></div>
                </div>
            }
            {
                (cita.peso && cita.talla && checkSpecialityToShowIMC(cita)) &&
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><BiBody className="mr-2"/></div>
                    <div><span>IMC: {(cita?.imc != null && cita?.imc !== 'NaN') ? cita?.imc.toFixed(2) : '-'}</span>
                    </div>
                </div>
            }

            {/*{*/}
            {/*    company === 'colombia' && (*/}
            {/*        <div className="d-flex text-secondary mb-3 font-size-09rem">*/}
            {/*            <div><AiOutlineFile className="mr-2"/></div>*/}
            {/*            <div><span>MODALIDAD: {modalidad || ' - '}</span></div>*/}
            {/*        </div>*/}
            {/*    )*/}
            {/*}*/}

        </>
    )

}

export default withTranslation()(InfoSencondaryPatient)